export const developEnvVariables = {
  environment: 'development',
  apiHost: 'https://uat-tyonantaja-api.edenred.fi', // QA 'http://fi-cicd.edenred.net:8183'; //  LOCAL 'https://localhost:44378'; //https://uat-tyonantaja-api.edenred.fi //http://fi-cicd.edenred.net:8083
  enablePersistanceOnLocalStorage: true,
  disablePersistanceCompression: true,
  disableReCaptcha: false,
  googleAnalyticsKey: '',
  onetrustKey: '',
  enableLoadingType: true,
  enableVirikeLoadingType: true,
  enableDepositsUpdate: true,
  depositUpdateAllowedIds: '677;90031096;90031374;345',
  enableMassUpload: true,
  ingestroLicenseKey: ''
};
